export function uniqBy<T extends Record<string, unknown> | undefined, K extends NonNullable<T>>(
  items: T[],
  property: keyof K,
): K[] {
  const seen: Record<string, boolean> = {}

  // @ts-ignore
  return items.filter(item => {
    if (!item) {
      return false
    }

    // @ts-ignore
    const val = item[property]
    // Prefix the key with its type to distinguish between strings and numbers
    const key =
      // oxlint-disable-next-line no-nested-ternary
      typeof val === 'string'
        ? `string:${val}`
        : // oxlint-disable-next-line unicorn/no-nested-ternary
          typeof val === 'number'
          ? `number:${val}`
          : JSON.stringify(val)

    if (seen[key]) {
      // oxlint-disable-next-line no-else-return
      return false
    } else {
      seen[key] = true
      return true
    }
  })
}

export function unArray(value: string | string[] | undefined) {
  return Array.isArray(value) ? value[0] : value
}
